export default __webpack_public_path__ + "static/media/news97.3bf73c19.jpg";